import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-download-up',
  templateUrl: './download-up.component.html',
  styleUrls: ['./download-up.component.scss']
})
export class DownloadUpComponent implements OnInit {

  constructor() {}

  ngOnInit(): void {}

}
